import PaymentStats from './PaymentStats';

export default PaymentStats;
